import { useEffect, useState, useCallback } from "react";
import api from '../services/api';
import "./JobListPage.styled.css";
import ModalBox from "../components/ModalBox";

function JobListPage() {
  const [jobs, setJobs] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [jdFile, setJdFile] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const fetchJobs = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await api.get(`/jobs`);
      setJobs(res.data);
    } catch {
      alert("Failed to fetch jobs");
    } finally {
      setIsLoading(false);
    }
  }, []);

  const filteredJobs = jobs.filter((job) =>
    job.title.toLowerCase().includes(search.toLowerCase())
  );

  const formatDateDiff = (createdAt) => {
    const created = new Date(createdAt);
    const now = new Date();
    const diffMs = now - created;
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMinutes < 1) return "Just now";
    if (diffMinutes < 60) return `${diffMinutes} minute(s) ago`;
    if (diffHours < 24) return `${diffHours} hour(s) ago`;
    if (diffDays < 7) return `${diffDays} day(s) ago`;

    return `Created at ${created.toLocaleDateString()}`;
  };

  const handleCreateJob = async () => {
    setIsCreating(true);
    const formData = new FormData();
    formData.append("title", newTitle);
    if (jdFile) formData.append("jd_file", jdFile);

    try {
      await api.post(`/jobs`, formData);
      setNewTitle("");
      setJdFile(null);
      setShowModal(false);
      fetchJobs();
    } catch (err) {
      alert("Error creating job");
    } finally {
      setIsCreating(false);
    }
  };

  const handleDeleteJob = async (id) => {
    if (!window.confirm("Are you sure you want to delete this job?")) return;
    try {
      await api.delete(`/jobs/${id}`);
      fetchJobs();
    } catch (err) {
      alert("Failed to delete job");
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  return (
    <div className="job-list-container">
      <h2>Jobs</h2>
      <div className="toolbar">
        <input
          placeholder="Search jobs..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button onClick={() => setShowModal(true)}>+ Create Job</button>
      </div>

      <div className="job-grid">
        {isLoading ? (
          <div className="loading-message">Loading jobs...</div>
        ) : (
          filteredJobs.map((job) => (
            <div className="job-card" key={job.id} onClick={() => window.location.href = `/jobs/${job.id}`}>
              <h4>{job.title}</h4>
              <p>Available: {job.cv_count} CV(s)</p>
              <p className="created-time">{formatDateDiff(job.created_at)}</p>
              <button onClick={(e) => {
                e.stopPropagation();
                handleDeleteJob(job.id);
              }}>🗑</button>
            </div>
          ))
        )}
      </div>

      {showModal && (
        <ModalBox title="Create New Job">
          <input
            type="text"
            className="modal-input"
            placeholder="Job title"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
          />
          <input
            type="file"
            className="modal-input"
            onChange={(e) => setJdFile(e.target.files[0])}
          />
          <div className="modal-buttons">
            <button onClick={handleCreateJob} disabled={isCreating}>
              {isCreating ? "Create..." : "Create"}
            </button>
            <button className="cancel-btn" onClick={() => setShowModal(false)}>
              Cancel
            </button>
          </div>
        </ModalBox>
      )}

    </div>
  );
}

export default JobListPage;
